import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/local-tourism-product-list',
      name: 'admin-local-tourism-product-list',
      component: () => import(/* webpackChunkName: "page-admin-tourism-product-management-local-tourism-product-list" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "旅游当地游产品列表"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "旅游产品管理"
                                        },
                                        {
                                                  name: "旅游当地游产品列表"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
